import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { CloudAccount } from "../../schema/types/cloudaccount/entity";

export const cloudAccountApi = createApi({
  reducerPath: "cloudAccountApi",
  baseQuery: customBaseQuery,
  tagTypes: ["CloudAccount"],
  endpoints: (builder) => ({
    getCloudAccount: builder.query<CloudAccount, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "CloudAccount", id: link }],
    }),
  }),
});

export const { useGetCloudAccountQuery } = cloudAccountApi;
